/*
 * @Author: ljc_625738144@qq.com
 * @Date: 2023-09-27 15:43:17
 * @LastEditors: ljc_625738144@qq.com
 * @LastEditTime: 2025-06-25 17:42:01
 * @Description:
 * @FilePath: \haozhang_pro\src\router\index.js
 */
import Vue from 'vue'
import Router from 'vue-router'
import index from "@/pages/index";
import store from '@/store/index';


Vue.use(Router);

const router = new Router({
	mode: 'history',
    base: __dirname,
	scrollBehavior: () => ({ y: 0 }),
	routes: [
		{
			path: '/login',
			component: resolve=> require(['@/pages/login'],resolve)
		},{
			path: '/reportDesk',
			 redirect:'/reportDesk/dashboard',
			component: resolve=> require(['@/pages/reportDesk'],resolve),
			children: [
				{
					path: '/reportDesk/dashboard',
					component: resolve=> require(['@/pages/dashboard'],resolve),
				},{
					path: '/reportDesk/report_form',
					component: resolve=> require(['@/pages/report_form'],resolve),
				}
			]
		},
	]
})


router.beforeEach((to,form,next)=>{
	let _this = new Vue();
	if(to.path != '/login'){
		if(sessionStorage.getItem('token') && sessionStorage.getItem('menu')){
			if (to.matched.length ===0) {  //如果未匹配到路由
				form.name ? next() : next('/error');   //如果上级也未匹配到路由则跳转登录页面，如果上级能匹配到则转上级路由
			} else {
				next();    //如果匹配到正确跳转
			}
		}else{
			let query,vars,obj={};
			query = window.location.search.substring(1);
			vars = query.split("&");
			for(var i=0;i<vars.length;i++) {
				obj[vars[i].split("=")[0]] = vars[i].split("=")[1];
			}
			if(obj.token && obj.cid) {
				sessionStorage.setItem('token' , obj.token);     // http://192.168.1.254/crm/index
				sessionStorage.setItem('cid' , obj.cid);
				_this.$http.post('sys/menu/getTree',{token:  obj.token, cid:  obj.cid}).then((msg)=>{
					if(msg && msg.data.code == '1'){
						 store.commit('ADDROUTECHILD' , msg.data.data);
						_this.$setSessionStorage('menu',msg.data.data);
							if(msg.data.data.length) {
									_this.$http.post('sys/account/getCrmUserInfo',{}).then(res=>{
										if(res.data && res.data.code == '1') {
											 _this.$setSessionStorage("userId",res.data.data.accountId);
											const defaultDisplay = res.data.data.defaultDisplay;
											_this.$setSessionStorage("userType_s" , res.data.data.account.userType)
											_this.$setSessionStorage('user',res.data.data);
                      _this.$setSessionStorage("userMssage_name",res.data.data.account.userName || res.data.data.account.userLoginName)
											_this.$setSessionStorage('userMssage_number',res.data.data.account.userLoginName);
											sessionStorage.setItem('bookName_first',res.data.data.bookName);
											store.commit('IS_FIRST_LOGIN' , res.data.data.first);
											next('/home');
										}
									})


							}else {
								//_this.$message.warning('系统提示：当前账户无权限！')
							}

					}else {
						next('/login');
					}
				})
			}else {
				next('/login');
			}
		}


	}else{
		sessionStorage.clear();
		next();
	}
});

 export default router;



// WEBPACK FOOTER //
// ./src/router/index.js